import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import ConfigurationGroupForm from './components/configuration-group-form/ConfigurationGroupForm';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { ModelName } from '@casops/store/api';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useGetConfigurationGroupQuery } from '@casops/store/apis/configurationGroupsApi';

const modelName = ModelName.ConfigurationGroup;

export function ManageConfigurationGroup(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetConfigurationGroupQuery,
  });

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey({ item });

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <ConfigurationGroupForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageConfigurationGroup;
